import { atomWithQuery } from 'jotai-tanstack-query';
import { IChildParentalAuthorityStatus } from '@/shared/interfaces';
import { fetchChildrenParentalAuthorityStatus } from '@/features/shared/features/addOrEditChild/api/fetchChildrenParentalAuthorityStatus';

export const fetchChildrenParentalAuthorityStatusQueryAtom = atomWithQuery<
    IChildParentalAuthorityStatus[]
>(() => ({
    queryKey: ['childrenParentalAuthorityStatus'],
    queryFn: async () => {
        return fetchChildrenParentalAuthorityStatus();
    },
    initialData: [],
    enabled: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
}));
